import { useTheme } from '@emotion/react';
import PropTypes from 'prop-types';

import Avatar from 'shopper/components/Avatar';

import { getUserAvatarUrl } from 'lib/image';
import { isGenieUser, isUserAdmin } from 'lib/user';

// Others sizes have the same size on all resolutions, these won't need
// to use responsive images.
const isResponsiveImageNeeded = (size) => size === 'size1' || size === 'size2';

const sizePropToImageSizeMap = {
  size1: {
    sm: 140,
    // 158
    lg: 160,
  },
  size2: {
    sm: 124,
    lg: 140,
  },
  size3: {
    sm: 108,
    lg: 108,
  },
  size4: {
    // 76
    sm: 80,
    lg: 80,
  },
  size5: {
    sm: 60,
    lg: 60,
  },
};

const UserAvatar = ({
  description,
  size,
  userId,
  userLevel,
  userName,
  userPhoto,
  userPhotoSize,
  userTypeName,
  ...rest
}) => {
  const theme = useTheme();
  const useResponsiveImage = isResponsiveImageNeeded(size) && !userPhotoSize;

  return (
    <Avatar
      admin={isUserAdmin(userTypeName)}
      description={description || `Imagem do usuário ${userName}`}
      level={userId && isGenieUser(userId) ? undefined : userLevel}
      size={size}
      sizes={
        useResponsiveImage
          ? `(max-width: ${theme.breakpoints[2]}) ${sizePropToImageSizeMap[size].sm}px, ${sizePropToImageSizeMap[size].lg}px`
          : null
      }
      src={getUserAvatarUrl(
        userPhoto,
        userPhotoSize || sizePropToImageSizeMap[size].sm
      )}
      srcSet={
        useResponsiveImage
          ? `${getUserAvatarUrl(userPhoto, sizePropToImageSizeMap[size].sm)} ${
              sizePropToImageSizeMap[size].sm
            }w, ${getUserAvatarUrl(
              userPhoto,
              sizePropToImageSizeMap[size].lg
            )} ${sizePropToImageSizeMap[size].lg}w`
          : null
      }
      {...rest}
    />
  );
};

UserAvatar.defaultProps = {
  description: null,
  // This does not have the same behavior as `Image` component as it was
  // done after `Avatar` was already being used in production. It would imply
  // to have all `Avatar`s with lazy loading, which could impact performance
  // negatively
  loading: null,
  size: 'size4',
  userId: null,
  userLevel: null,
  userName: null,
  userPhoto: null,
  userPhotoSize: null,
  userTypeName: null,
};

UserAvatar.propTypes = {
  description: PropTypes.string,
  loading: PropTypes.oneOf(['eager', 'lazy']),
  size: PropTypes.string,
  userId: PropTypes.number,
  userLevel: PropTypes.number,
  userName: PropTypes.string,
  userPhoto: PropTypes.string,
  userPhotoSize: PropTypes.number,
  userTypeName: PropTypes.string,
};

export default UserAvatar;
